import { Spin, Table } from 'antd';
import { useState } from 'react';
import { useRequest } from 'ahooks';
import {
  bool, object,
} from 'prop-types';
import { isEmpty, isNumber, isUndefined } from 'lodash';
import FilterType from '@/components/FilterType/FilterType';
import FilterTypeChild from '@/components/FilterType/FilterTypeChild';
import EmptyImg from '@/components/EmptyImg/EmptyImg';
import { getCreditGuaranteePublicList } from '@/services/creditGuarantee';
import './PublicList.less';

const startYear = 2023;
const endYear = new Date().getFullYear(); // 当前年份
const years = Array.from({ length: endYear - startYear + 1 }, (_, i) => {
  const item = { val: startYear + i, name: startYear + i };
  return item;
});
/**
 * 产品列表组件
 * @param {object} data 数据源
 * @param {bool} isShow 是否显示按钮
 * @param {string} type 类型银行产品\保险产品
 * @param {bool} filter 是否显示筛选条件
 * */
export default function PublicList({
  data, filter,
}) {
  const { area } = data;
  const [list, setList] = useState({});
  const [val, setVal] = useState({});
  const [childArea, setChildArea] = useState([]);

  const { run, loading } = useRequest(getCreditGuaranteePublicList, { // 保险产品
    onSuccess(res) {
      setList(res);
    },
  });

  function getData(e) {
    run({ ...e });
  }

  function onChange(page, size) {
    getData({ ...val, pageNum: page, pageSize: size });
  }

  function filterArea(areaID) {
    const matched = area.filter((v) => v.id === areaID);
    const { children } = matched[0];
    return children;
  }

  function handleFilter(arr, t) {
    let obj = { ...val };
    if (t === 'cityCode' || t === 'areaCode') {
      if (t === 'cityCode') {
        if (arr) {
          const childrenArea = filterArea(arr[0]);
          setChildArea(childrenArea);
          obj = { ...obj, regionVo: { cityCode: arr[0] } };
        } else {
          // 全部城市则不需要参数
          setChildArea([]);
          obj = { ...obj, regionVo: {} };
        }
        setVal(obj);
        getData(obj);
      } else if (t === 'areaCode') {
        if (arr) {
          obj = { ...obj, regionVo: { ...obj.regionVo, areaCode: arr[0] } };
        } else {
          // 全部区县则只需要市级参数
          obj = { ...obj, regionVo: { cityCode: obj.regionVo.cityCode } };
        }
        setVal(obj);
        getData(obj);
      }
    } else {
      obj = { ...val, [t]: isUndefined(arr) ? null : arr[0] };
      setVal(obj);
      getData(obj);
    }
  }

  function tableTitle() {
    const { year } = val;

    return (
      <div style={{ fontSize: '20px', fontWeight: 600, textAlign: 'center' }}>
        {isNumber(year) ? `${year}年` : ''}
        农业信贷担保拟补助资金情况公告公示表
      </div>
    );
  }

  const columns = [
    {
      title: '市州',
      dataIndex: 'cityCode',
      align: 'center',
    },
    {
      title: '区县',
      dataIndex: 'areaCode',
      align: 'center',
    },
    {
      title: '担保机构',
      dataIndex: 'guaranteeName',
      align: 'center',
    },
    // {
    //   title: '核定补助金额（万元）',
    //   align: 'center',
    //   children: [
    //     {
    //       title: '粮食生产经营贷款类',
    //       dataIndex: 'provinceExamineProduction',
    //       align: 'center',
    //     },
    //     {
    //       title: '现代农业发展贷款类',
    //       dataIndex: 'provinceExamineAgriculture',
    //       align: 'center',
    //     },
    //     // {
    //     //   title: '小计',
    //     //   dataIndex: 'provinceExamineGrant',
    //     //   align: 'center',
    //     // },
    //   ],
    // },
    {
      title: '核定补助金额（万元）',
      dataIndex: 'provinceExamineGrant',
      align: 'center',
    },
    {
      title: '公示单位联系电话',
      dataIndex: 'publicationTel',
      align: 'center',
    },
  ];

  return (
    <div className="bank-product">
      <Spin spinning={loading}>
        <span className="pl-filter-title">筛选条件</span>
        {
          filter && (
            <div className="product-filter">

              <FilterType title="申报年度" titleWidth={88} data={years} radio onChange={(e) => handleFilter(e, 'year')} />
              {
                !isEmpty(data?.area) && (
                  <FilterType title="申报区域" titleWidth={88} data={data?.area} radio onChange={(e) => handleFilter(e, 'cityCode')} />
                )
              }
              {
                !isEmpty(childArea) && (
                  <FilterTypeChild title="" data={childArea} radio onChange={(e) => handleFilter(e, 'areaCode')} />
                )
              }
            </div>
          )
        }
        <span className="pl-list-title">情况公示</span>
        {
          isEmpty(list?.items) ? (<EmptyImg height={300} />) : (
            <div className="product-list">
              <Table
                title={tableTitle}
                columns={columns}
                rowKey="id"
                dataSource={list?.items}
                scroll={{ x: 1000 }}
                pagination={{
                  onChange,
                  current: list?.pageNum,
                  total: list?.totalRows,
                }}
              />
            </div>
          )
        }
      </Spin>
    </div>
  );
}

PublicList.propTypes = {
  filter: bool,
  data: object,
};

PublicList.defaultProps = {
  filter: true,
};
